// extracted by extract-css-chunks-webpack-plugin
module.exports = {"iconTooltip":"_26Nu-","iconToolTipRes":"PT6qK"};